import React, { useMemo } from "react";
import { isNumber } from "lodash";

import ExecutorReport from "../../../../../../../../../../services/ExecutorReport";
import formatNumber from "../../../../../../../../../../utils/formatNumber";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

export const cellProcessing = (item: DueAmountCellContent.Props["item"]) => {
	if (!item) return "";
	if (!isNumber(item.dueAmount)) return "";
	return formatNumber(item.dueAmount);
};

const DueAmountCellContent: React.FC<DueAmountCellContent.Props> = ({
	item,
}) => {
	const content = useMemo(() => cellProcessing(item), [item]);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace DueAmountCellContent {
	interface Props {
		item: ExecutorReport.Model;
	}
}

export default DueAmountCellContent;
